import users from "@/api/users";

export default {
  namespaced: true,
  state: {
    items: [],
    user: null,
    selectedItems: null,
    editedId: -1,
    customers: [],
    editedItem: {
      firstName: "",
      email: "",
      lastName: "",
      userRole: "",
      active: false,
    },
    defaultItem: {
      firstName: "",
      email: "",
      lastName: "",
      userRole: "",
      active: false,
    },
    selectedCustomer: {
      id: -1,
      logo: null,
      name: "",
      status: -1,
    },
  },
  actions: {
    fetchAll({ commit }, data) {
      return users.get(data).then((response) => {
        commit("setItems", response.data);
        return response;
      });
    },
    fetchCurrentUser({ commit }) {
      return users.currentUser().then((response) => {
        commit("setUser", response.data);
        return response;
      });
    },
    fetchStrykerUsers({ commit }) {
      return users.getStrykerUsers().then((response) => {
        commit("setItems", response.data);
        return response;
      });
    },
    sendLink(context, data) {
      return users.sendLink(data);
    },
    getUserInfosWithCustomers({ commit }) {
      return users.getUserInfosWithCustomers().then((response) => {
        commit("setUser", response.data.user);
        commit("setCustomers", response.data.customers);
        return response.data;
      });
    },
    resetSelectedCustomer({ commit }) {
      commit(
        "setSelectedCustomer",
        Object.assign(
          {},
          {
            id: -1,
            logo: null,
            name: "",
            status: -1,
          },
        ),
      );
    },
    saveEditedItem({ dispatch, state, rootState }, roleId) {
      let role = "";
      if (Number.isInteger(roleId)) {
        role = rootState.roles.items.find((r) => r.id === roleId).name;
      } else {
        role = roleId;
      }
      const user = {
        firstName: state.editedItem.firstName,
        lastName: state.editedItem.lastName,
        email: state.editedItem.email,
        active: state.editedItem.active,
        userRole: role,
      };
      return users.store(user).then((response) => {
        dispatch("fetchAll");
        dispatch("resetEditedItem");
        return response;
      });
    },
    updateEditedItem({ dispatch, state, rootState }, roleId) {
      let role = "";
      if (Number.isInteger(roleId)) {
        role = rootState.roles.items.find((r) => r.id === roleId).name;
      } else {
        role = roleId;
      }
      const user = {
        firstName: state.editedItem.firstName,
        lastName: state.editedItem.lastName,
        email: state.editedItem.email,
        active: state.editedItem.active,
        userRole: role,
        id: state.editedId,
      };
      return users.update(state.editedId, user).then((response) => {
        dispatch("fetchAll");
        dispatch("resetEditedItem");
        return response;
      });
    },
    deleteItem(context, id) {
      return users.delete(id);
    },
    resetEditedItem({ commit, state }) {
      commit("setEditedId", -1);
      commit("setEditedItem", Object.assign({}, state.defaultItem));
    },
  },
  mutations: {
    setUser(state, user) {
      state.user = user;
    },
    setSelectedCustomer(state, customer) {
      const selectedCustomer = {
        id: customer.id,
        logo: customer.logo,
        name: customer.name,
        status: customer.status,
      };
      window.localStorage.setItem("cust_stryker_one", JSON.stringify(customer));
      state.selectedCustomer = selectedCustomer;
    },
    setCustomers(state, customers) {
      state.customers = customers;
    },
    setItems(state, items) {
      state.items = items;
    },
    setEditedItem(state, item) {
      state.editedItem = { ...item };
    },
    setEditedId(state, id) {
      state.editedId = id;
    },
    setDefaultItem(state) {
      state.editedItem = { ...state.defaultItem };
    },
  },
};
